export const clientReportConstants = {   
    GET_CRITERIA_SUCCESS: 'CLIENT_REPORT_GET_CRITERIA_SUCCESS',
    GET_REPORT_REQUEST: 'CLIENT_REPORT_GET_REPORT_REQUEST',
    GET_REPORT_SUCCESS: 'CLIENT_REPORT_GET_REPORT_SUCCESS',
    GET_REPORT_FAILURE: 'CLIENT_REPORT_GET_REPORT_FAILURE',
    REPORT_FIELDS: 'CLIENT_REPORT_REPORT_FIELDS'
};
